import { Component, inject, output, input } from '@angular/core';
import { PanoptycDataService } from '../../../service/panoptyc-data.service';
import { UserLoginService } from '../../../service/user-login.service';
import { Router } from '@angular/router';
import { hasStatus } from '../../../error.utils';

@Component({
  selector: 'app-comment-input',
  templateUrl: './comment-input.component.html',
  styleUrls: ['./comment-input.component.scss'],
  standalone: false,
})
export class CommentInputComponent {
  userService = inject(UserLoginService);
  router = inject(Router);
  private dataService = inject(PanoptycDataService);

  readonly cancellationId = input<string>();
  readonly commentSubmitStart = output<void>();
  readonly commentSubmitEnd = output<{ error: boolean }>();

  content: string = null;
  addingComment = false;

  handleDataForbidden(error: unknown) {
    if (hasStatus(error) && error.status === 403) {
      try {
        this.router.navigate(['/403']);
      } catch (e) {
        console.error(e);
      }
    }
  }

  onInputKeyUp(event) {
    this.content = event.target.value;
  }

  handleAddComment() {
    if (!this.content) {
      return;
    }
    this.addingComment = true;
    this.commentSubmitStart.emit();
    this.dataService.addTransactionComments(this.cancellationId(), this.content).subscribe(
      () => {
        this.commentSubmitEnd.emit({ error: false });
        this.addingComment = false;
        this.content = '';
      },
      (error) => {
        this.handleDataForbidden(error);
        this.commentSubmitEnd.emit({ error: true });
        this.addingComment = false;
      },
    );
  }
}
